import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';

const SuggestionItem = (_param)=>{
    var { className , active , suggestion , setFocus , onBlur , setHovered , onSuggestionClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "active",
        "suggestion",
        "setFocus",
        "onBlur",
        "setHovered",
        "onSuggestionClick"
    ]);
    const { title , subTitle , cursor , id  } = suggestion;
    const onFocus = React__default.useCallback(()=>setFocus(cursor)
    , [
        setFocus,
        cursor
    ]);
    const onMouseEnter = React__default.useCallback(()=>setHovered(suggestion)
    , [
        setHovered,
        suggestion
    ]);
    const onMouseLeave = React__default.useCallback(()=>setHovered(undefined)
    , [
        setHovered
    ]);
    const onClick = React__default.useCallback(()=>onSuggestionClick(id)
    , [
        id,
        onSuggestionClick
    ]);
    return /*#__PURE__*/ React__default.createElement("li", swcHelpers.extends({}, rest, {
        role: "presentation",
        className: classnames('autocomplete-suggestions-item', {
            'autocomplete-suggestions-item--active': active
        }, className)
    }), /*#__PURE__*/ React__default.createElement("button", {
        id: `autocomplete-suggestion-item-${cursor}`,
        role: "option",
        "aria-selected": active,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        className: "autocomplete-suggestions-item__button"
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: "autocomplete-suggestions-item__button--title"
    }, title), subTitle && /*#__PURE__*/ React__default.createElement("span", {
        "data-t": "suggestion-sub-title",
        className: "autocomplete-suggestions-item__button--subtitle"
    }, ' ', subTitle)));
};
var SuggestionItem$1 = SuggestionItem;

export { SuggestionItem$1 as default };
//# sourceMappingURL=SuggestionItem.js.map
